import { useQuery } from '@tanstack/react-query'
import { topNewBooksKeys } from '@!/Api/queryKeys'
import { getTopNewBooksApi } from '@!/Api/newBooks'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useTopNewBooks = (genreName) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  const { data } = useQuery({
    queryKey: topNewBooksKeys.filtered(safeSearch, genreName),
    queryFn: async () => {
      return await getTopNewBooksApi(safeSearch, genreName)
    },
    refetchOnWindowFocus: false,
  })

  return data || []
}
